import { ImageWithFallback } from './ImageWithFallback';
import { Users, BookOpen, Heart, Award } from 'lucide-react';
import welcomeImage from '../../assets/img/HomePage/welcome-image.jpeg';


const VisionAndMissionComponent = () => {
    const features = [
        {
            icon: Users,
            title: 'Community Building',
            description: 'Fostering strong bonds among members through regular gatherings and cultural programs.',
        },
        {
            icon: BookOpen,
            title: 'Cultural Heritage',
            description: 'Preserving and promoting our rich traditions, language, and spiritual practices.',
        },
        {
            icon: Heart,
            title: 'Social Welfare',
            description: 'Supporting members through educational scholarships, healthcare assistance, and community aid.',
        },
        {
            icon: Award,
            title: 'Excellence',
            description: 'Recognizing and celebrating achievements of community members in various fields.',
        },
    ];

    return (
        <section id="about" className="py-20 bg-gray-50">
            <div className="container mx-auto px-4">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-5xl text-[#4A0404] mb-4">
                        ಚಿಂತಾಮಣಿ ತಾಲ್ಲೂಕು ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾಗೆ ಸ್ವಾಗತ
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        ವೇದ -ಧರ್ಮ -ಸಂಸ್ಕೃತಿ -ನಿತ್ಯ ಸೇವೆಯ ಹಾದಿ
                    </p>
                </div>

                {/* Main Content */}
                <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
                    <div>
                        {/* <h3 className="text-3xl text-[#4A0404] mb-6">
                            Building Bridges, Preserving Traditions
                        </h3> */}
                        <p className="text-gray-700 mb-4">
                            ಚಿಂತಾಮಣಿ ತಾಲ್ಲೂಕು ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭೆ —1970ರ ದಶಕದಲ್ಲಿ ಪ್ರಾರಂಭವಾದ ಸಂಘ ಸಣ್ಣಪುಟ್ಟ ಕಾರ್ಯಕ್ರಮಗಳನ್ನು ಮಾಡಿಕೊಂಡು ಇಂದು ಮಾದರಿ ಸಂಘವಾಗಿ ಬೆಳೆದದ್ದು ಒಂದು ಇತಿಹಾಸ.  ಐವತ್ತು ವರ್ಷಗಳ ಸುದೀರ್ಘ ಕಾಲದಲ್ಲಿ ಈ ಮಹಾಸಭೆ ಧಾರ್ಮಿಕ, ಶೈಕ್ಷಣಿಕ ಮತ್ತು ಸಾಮಾಜಿಕ ಕ್ಷೇತ್ರಗಳಲ್ಲಿ ತೊಡಗಿಸಿಕೊಂಡಿದೆ.
                        </p>
                        <p className="text-gray-700 mb-4">
                            2015 ರಿಂದ ಸಂಘವು ಅನೇಕ ಧಾರ್ಮಿಕ ಕಾರ್ಯಕ್ರಮಗಳನ್ನು ಮಾಡಿಕೊಂಡು ಬಂದಿದ್ದು ಒಂದು ಇತಿಹಾಸ. ಅದರಲ್ಲಿ <br />
                            1) ದಶಲಕ್ಷ ಗಾಯತ್ರಿ ಜಪ ಯಜ್ಞ<br />
                            2) ಅರುಣ ಹೋಮ<br />
                            3)ಮೊಟ್ಟ ಮೊದಲ ಬಾರಿ ಬ್ರಾಹ್ಮಣ ಸಂಘದ ವತಿಯಿಂದ ರಾಜ್ಯೋತ್ಸವ ಆಚರಣೆ.<br />
                            4)ಸುಮಾರು 15 ವರ್ಷಗಳಿಂದ ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ.<br />
                            5)ಸಂಘದ ಕಾರ್ಯಾಲಯ ಉದ್ಘಾಟನೆ<br />                            
                            6) ಬೆಂಗಳೂರಿನಲ್ಲಿ AKBMS ವತಿಯಿಂದ ನಡೆದ 3ನೇ ರಾಜ್ಯಮಟ್ಟದ ಮಹಿಳಾ ಸಮ್ಮೇಳನಕ್ಕೆ "ಅಭಿಜಾತೆ" ಗೆ ಚಿಂತಾಮಣಿಯಿಂದ ಹಾಜರಾತಿ.<br />
                            7)ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾ ವತಿಯಿಂದ ತಾಲ್ಲೂಕಿನ ಎಲ್ಲ ವಿಪ್ರ ಬಂಧುಗಳ ಡೈರೆಕ್ಟರಿ ಬಿಡುಗಡೆ
                        </p>
                        <p className="text-gray-700">
                            ಮುಂದೆಯೂ ಅನೇಕ ಕಾರ್ಯಕ್ರಮಗಳನ್ನು ಸಂಘದ ವತಿಯಿಂದ ಹಮ್ಮಿಕೊಳ್ಳಲು ಉದ್ದೇಶಿಸಲಾಗಿದೆ. ಮುಖ್ಯವಾಗಿ ಆರೋಗ್ಯ, ಸಾಮಾಜಿಕ, ಮತ್ತು ಶೈಕ್ಷಣಿಕವಾಗಿ ಸಮಾಜದ ಒಳತಿಗಾಗಿ ಕೆಲಸ ಮಾಡಲು ನಿರ್ಧರಿಸಲಾಗಿದೆ. ಇದಕ್ಕೆ ಎಲ್ಲ ವಿಪ್ರ ಬಂಧುಗಳು ಸಹಕಾರ ನೀಡಲು  ವಿನಮ್ರವಾಗಿ ಕೋರುತ್ತೇವೆ.
                        </p>
                    </div>
                    <div className="relative">
                        <div className="absolute -top-4 -left-4 w-full h-full bg-gradient-to-br from-[#800000] to-[#F59E0B] rounded-lg"></div>
                        <ImageWithFallback
                            src={welcomeImage}
                            alt="Community Gathering"
                            className="relative rounded-lg shadow-xl w-full h-[400px] object-cover"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
export default VisionAndMissionComponent; 